import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import DashboardNavbar from "./Navbar";
import { useAppSelector } from "../app/hooks";
import { getUserConfig, resetState } from "../features/dashboard/userSlice";

export default function Layout() {
  const dispatch = useDispatch();
  const { config, isSuccess } = useAppSelector((state) => state.user);

  useEffect(() => {
    if (!config) {
      dispatch(getUserConfig());
    }
  }, [dispatch, config]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(resetState());
    }
  }, [dispatch, isSuccess]);

  return (
    <>
      <DashboardNavbar />
      {config ? <Outlet /> : ""}
      <ToastContainer
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        autoClose={2000}
        hideProgressBar={true}
      />
    </>
  );
}
